/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Kind_Event_DescriptionInputs */



/**
* | output |
* | --- |
* | "Run when a connected system reports a change, like a new sales order in Business Central." |
*
* @param {Agent_Triggers_Kind_Event_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_kind_event_description = /** @type {((inputs?: Agent_Triggers_Kind_Event_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Kind_Event_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausführen, wenn ein verbundenes System eine Änderung meldet, etwa einen neuen Verkaufsauftrag in Business Central.")
	return /** @type {LocalizedString} */ ("Run when a connected system reports a change, like a new sales order in Business Central.")
});